import api from './api';

export interface Ticket {
  id: number;
  dms_ticket_code: string;
  title: string;
  description?: string;
  sql_content?: string;
  database_name?: string;
  submitter_id?: number;
  submitter_dms_uid: string;
  submitter_name: string;
  assignee_id?: number;
  status: 'pending' | 'approved' | 'rejected' | 'executed' | 'failed';
  priority: 'low' | 'normal' | 'high' | 'urgent';
  event_type?: string;
  created_at: string;
  updated_at: string;
  submitter?: {
    id: number;
    name: string;
    wechat_userid: string;
    department?: string;
  };
  assignee?: {
    id: number;
    name: string;
    wechat_userid: string;
    department?: string;
  };
  approvals?: Approval[];
}

export interface Approval {
  id: number;
  ticket_id: number;
  approver_id: number;
  action: string;
  comment?: string;
  created_at: string;
  approver?: {
    id: number;
    name: string;
    department?: string;
    wechat_userid: string;
  };
}

export interface ApprovalRequest {
  action: 'approve' | 'reject';
  comment?: string;
}

export const ticketService = {
  // 获取工单列表
  async getTickets(params?: {
    skip?: number;
    limit?: number;
    status_filter?: string;
  }): Promise<Ticket[]> {
    const response = await api.get('/tickets', { params });
    // 处理API返回的数据格式 {tickets: [], total: 0}
    if (response.data && response.data.tickets) {
      return response.data.tickets;
    }
    // 如果直接返回数组格式，也兼容
    return Array.isArray(response.data) ? response.data : [];
  },

  // 获取工单详情
  async getTicketDetail(id: number): Promise<Ticket> {
    const response = await api.get(`/tickets/${id}`);
    return response.data;
  },

  // 审批工单
  async approveTicket(id: number, data: ApprovalRequest): Promise<void> {
    await api.post(`/tickets/${id}/approve`, data);
  },

  // 获取工单审批历史
  async getTicketHistory(id: number): Promise<Approval[]> {
    const response = await api.get(`/tickets/${id}/history`);
    return response.data;
  },
};

